import * as HttpService from './HttpService'

let namespace = 'projects'

const find = (params, cb, errorCb) => {
    HttpService.get(namespace, params, cb, errorCb)
}

const between = (dateFrom, dateTo, department, params, cb, errorCb) => {
    params = {
        ...params,
        ...{'filter[between]': dateFrom + ',' + dateTo},
        ...{'per_page': 50}
    }
    if (department.uuid) {
        params = {...params, ...{'filter[department]': department.name}}
    }
    HttpService.get(namespace, params, cb, errorCb)
}

const update = (params, cb, errorCb) => {
    HttpService.post(namespace + '/update', params, cb, errorCb)
}

const claims = (params, cb, errorCb) => {
    HttpService.get(namespace, params, cb, errorCb)
}

export {
    find,
    between,
    update,
    claims
}



// WEBPACK FOOTER //
// ./src/services/projectService.js